module.exports = __webpack_public_path__ + "static/media/cloudformation-launch-stack.6763cefe.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/GettingStarted/cloudformation-launch-stack.png
 ** module id = 1366
 ** module chunks = 0
 **/